import { render, staticRenderFns } from "./BaseBreadcrumb.vue?vue&type=template&id=6a9524ce&scoped=true&"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./BaseBreadcrumb.vue?vue&type=style&index=0&id=6a9524ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9524ce",
  null
  
)

export default component.exports